import { useState, useEffect } from 'react';
import SearchForm from './SearchForm.js';
import PropertyResult from './PropertyResult.js';
import SearchHeader from './SearchHeader.js';
import SearchPagination from './SearchPagination.js';

export default function PropertySearchElements({ pageId, config, initialResults, initialUrl, content }) {
    const [results, setResults] = useState(initialResults);
    const formId = 'propertySearchForm';
    const [form, setForm] = useState(null);
    const [order, setSortOrder] = useState(config.OrderBy);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const baseUrl = initialUrl.split('?')[0];

    useEffect(() => {
        async function doSearch() {
            if (form != null) {
                form.set('OrderBy', order);
                setResults(null);
                if (form.get('Page')==null && config.Page!=null) {
                    form.set('Page', config.Page);
                }
                const response = await fetch('/ppi/propertysearchapi/dosearch/' + pageId, {
                    method: "POST",
                    body: form
                });
                const data = await response.json();
                window.history.replaceState(null, null, baseUrl + '?' + new URLSearchParams(Array.from(form)));
                setResults(data);
            }
        }
        doSearch();
    }, [form, order]);


    useEffect(() => {
        function handleResize() {
            setWindowWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function sortChanged(evt) {
        setSortOrder(evt.target.value);
    }

    function changePage(p) {
        const fd = new FormData(document.getElementById(formId));
        fd.set('Page', p);
        setForm(fd);
        window.scroll({ top: 0, behavior: 'smooth' });
    }

    return (
        <>
            <SearchForm config={config} onChange={() => setForm(new FormData(document.getElementById(formId)))} formId={formId} ctaContent={{ cta: content.cta, label: content.btnLabel }} isMobile={windowWidth <= 800 } />
            <div className="mt-1">
                <div id="propertySearchResults">
                    <SearchHeader results={results} orderOptions={config.OrderOptions} orderBy={order} onSortChange={sortChanged} includeBngProperties={config.IncludeBngProperties} introText={content.intro} introHeading={content.heading} />
                    <div className="grid-x grid-padding-x grid-padding-y results-grid">
                        {results == null &&
                            <div className="loading-spinner"></div>
                        }
                        {results != null &&
                            results.Properties.map(p => <PropertyResult property={p} key={p.Id} />)
                        }
                        {results != null && results.TotalResults == 0 &&
                            <div className="grid-container pt-2">
                                <div dangerouslySetInnerHTML={({ __html: content.noResults })}></div>
                            </div>
                        }
                    </div>
                </div>
                {results != null &&
                    <SearchPagination totalItems={results.TotalResults} pageSize={config.PageSize} page={results.PageNumber} pagesToShow={windowWidth > 800 ? 8 : 4} changePage={changePage} />
                }
            </div >
        </>
    );
}